import { BaseService } from "./common/base";
import type { QuestionnaireResponse } from "../../../../api/src/questionnaire-response/entities/questionnaire-response.entity";
import type { CreateQuestionnaireResponseDto } from "../../../../api/src/questionnaire-response/dto/create-questionnaire-response.dto";
import type { UpdateQuestionnaireResponseDto } from "../../../../api/src/questionnaire-response/dto/update-questionnaire-response.dto";

export class QuestionnaireResponseService extends BaseService<
  QuestionnaireResponse,
  any,
  CreateQuestionnaireResponseDto,
  UpdateQuestionnaireResponseDto
> {
  constructor() {
    super("questionnaire-response");
  }
}
